import { LOCALES } from '../constants';

export default {
  [LOCALES.ENGLISH]: {

//INTRODUSING SECTION PAGE    
    'introducing_hello': 'Hello',
    'introducing_p2': 'Nice to meet you.',
    'introducing_im': `I'm`,
    'introducing_name': 'Misha Hubka.',
    'introducing_bio': `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                    Voluptatum necessitatibus perferendis numquam dolorem cumque facilis.
                    Desir per po la ta doso vi slone ve`,

//NAVBAR SECTION
    'home_link':'Home',
    'about_link':'About',
    'skills_link':'Skills',
    'projects_link':'Projects',
    'contact_link':'Contact',
    'footer':'2022 Misha Hubka',

//ABOUT PAGE SECTION
    'about_title':'About Me',
    'about_title_span':'About',
    'about_title_Skills':'My Skills',
    'about_title_Skills_span':'My Skills',

//ABOUT PAGE IMAGE SECTION
    'about_img_section_fullname': 'Full Name',
    'about_img_section_age': 'Age',
    'about_img_section_nationality': 'Nationality',
    'about_img_section_languages': 'Languages',
    'about_img_section_address': 'Address',
    'about_img_section_countries': 'Countries',

    'about_img_section_fullname_r': 'Misha Hubka',
    'about_img_section_age_r': '29',
    'about_img_section_nationality_r': 'Ukrainian',
    'about_img_section_languages_r': 'English, Ukrainian, Russian',
    'about_img_section_address_r': 'Chernivtsi oblast',
    'about_img_section_countries_r': 'Ukraine',
    'about_img_section_CV': 'Download Cv',
    'app_title': 'Misha hubka',

    //PROJECT PAGE SECTION
    'project_main_title': 'Study Projects',
    'project_main_title2': 'project',
    'project1_title_1' : 'Netflix clone',
    'project_titlesourse': 'Sourse code',
    'project2_title_1': 'Social network',
    'project2_description': 'Registration and post page. React.js Firebase',
    'project3_title_1': 'E-commerce website',
    'project4_title_1': 'Snapchat clone',

    //CONTACTS PAGE SECTION
    //CONTACT FORM SECTION
    'contact_form_title': 'Contact me',
    'contact_form_name': 'Name',
    'contact_form_email': 'Email',
    'contact_form_message': 'Message',
    'contact_form_send': 'Send',

    //CONTACT FORM VALIDATION
    'contact_form_name_field_required': 'Name is required',
    'contact_form_name_maxLength' : 'Length of Name must be less than 45 characters',
    'contact_form_email_required' : 'Email is required',
    'contact_form_email_notvalid' : 'Email not valid',
    'contact_form_message_required' : 'Message is required',
    'contact_form_message_maxLength' : 'Length of Message must be 2000 characters or less',
    'contact_form_message_sent' : 'Message sent!',
    'contact_form_message_sent_Failed' : 'Failed to send message! Please try again later',


    //CONTACT FIELD
    'contact_field1_title': 'Phone',
    'contact_field2_title': 'Email',
    'contact_field3_title': 'Address',
    'contact-field_adress_text1': 'Chernivtsi region',
    'contact-field_adress_text2': 'Ukraine',

    //CONTACT MAIN TITLE
    'contact_main_title1': 'Contacts',
    'contact_main_title2': 'Contact',
  },
};
